import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { deleteaccount, listaccounts } from "../../../../services/admin";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { isAdmin } from "../../../../utils/roles";

export default function AllAccounts() {
    const [filterProduct, setFilterProduct] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchAccounts();
    }, []);

    const fetchAccounts = () => {
        const branchId = localStorage.getItem("branch");
        listaccounts(branchId).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
            }
        });
    };

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 140,
            sortable: false,
            resizable: false,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        {isAdmin() && (
                            <>
                                <a
                                    onClick={() => navigate(`/accounts/editaccount/${params.value}`)}
                                    className="btn-sm btn-info me-2"
                                    title="Edit Account"
                                >
                                    <i className="fa fa-edit"></i>
                                </a>
                                {!params.data.is_system_account && (
                                    <a
                                        onClick={() => handleDelete(params.value)}
                                        className="btn-sm btn-danger me-2"
                                        title="Delete Account"
                                    >
                                        <i className="fa fa-trash"></i>
                                    </a>
                                )}
                            </>
                        )}
                    </div>
                );
            },
        },
        {
            headerName: "Account Code",
            field: "account_code",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Account Name",
            field: "account_name",
            width: 250,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Account Type",
            field: "account_type",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                const colors = {
                    Asset: "success",
                    Liability: "danger",
                    Income: "primary",
                    Expense: "warning",
                    Equity: "info",
                };
                return <span className={`badge bg-${colors[params.value]}`}>{params.value}</span>;
            },
        },
        {
            headerName: "Account Group",
            field: "account_group",
            width: 180,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Parent Account",
            field: "parent_account.account_name",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueGetter: function (params) {
                return params.data.parent_account ? params.data.parent_account.account_name : "-";
            },
        },
        {
            headerName: "Current Balance",
            field: "current_balance",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "right" },
            cellRenderer: function (params) {
                return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
            },
        },
        {
            headerName: "Status",
            field: "is_active",
            width: 120,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return params.value
                    ? <span className="badge bg-success">Active</span>
                    : <span className="badge bg-secondary">Inactive</span>;
            },
        },
    ];

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this account?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteaccount(id).then((res) => {
                    if (res.status === true) {
                        toast.success(res.message);
                        fetchAccounts();
                    }
                });
            }
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Chart of Accounts</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Chart of Accounts
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-6">
                                            <h4 className="card-title">Chart of Accounts</h4>
                                        </div>
                                        <div className="col-6 text-end">
                                            {isAdmin() && (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => navigate("/accounts/addaccount")}
                                                >
                                                    <i className="fa fa-plus"></i> Add Account
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
                                        <AgGridReact
                                            rowData={filterProduct}
                                            columnDefs={columnDefs}
                                            defaultColDef={{
                                                sortable: true,
                                                resizable: true,
                                            }}
                                            pagination={true}
                                            paginationPageSize={20}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
